import { CustomAxiosError } from '@calm/evexia-web-sdk';
import { ERROR_CODE } from '@rhg/constants';
import { identifyApiErrorCode } from '../axios';

export enum EligibilityErrorType {
    InvalidEmailDomain = 'invalidEmailDomain',
    EligibilityDenied = 'eligibilityDenied',
    MemberInactive = 'memberInactive',
    MemberActiveInFuture = 'memberActiveInFuture',
    ServerError = 'serverError',
}

/**
 * Only identifies eligibility errors.
 * Other error types like 500 server errors, or 400 request errors
 * should be handled by the caller
 */
export function identifyEligibilityErrorType(
    e: CustomAxiosError | null
): EligibilityErrorType | undefined {
    if (!e) {
        return;
    }

    if (e?.response?.status === 403) {
        const errorCode = e ? identifyApiErrorCode(e) : null;
        if (errorCode) {
            switch (errorCode) {
                case ERROR_CODE.EMAIL_DOMAIN_NOT_FOUND:
                    return EligibilityErrorType.InvalidEmailDomain;
                case ERROR_CODE.MEMBER_INACTIVE:
                    return EligibilityErrorType.MemberInactive;
                case ERROR_CODE.MEMBER_ACTIVE_IN_FUTURE:
                    return EligibilityErrorType.MemberActiveInFuture;
            }
        }
        return EligibilityErrorType.EligibilityDenied;
    }
}
